import { render, staticRenderFns } from "./data-set.vue?vue&type=template&id=64aa6fce&scoped=true"
import script from "./data-set.vue?vue&type=script&lang=js"
export * from "./data-set.vue?vue&type=script&lang=js"
import style0 from "./data-set.vue?vue&type=style&index=0&id=64aa6fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa6fce",
  null
  
)

export default component.exports